export const getFieldValidationAttrs = (fieldName, error) => {
  if (error) return { 'data-test': `${fieldName}-error-label` }

  return { 'data-test': `${fieldName}-helper-text-label` }
}
